<template>
  <div :class="{ 'client-eval-page--indiv': isIndiv }">
    <div class="bgimg">
      <div class="userlist client-eval-accounts">
        <div class="list_head">
          <div class="contnet" :style="{ minHeight: groupingContnetMinHeight }">
            <div class="client-eval-tabbar-el">
              <el-tabs v-model="groupingTab">
                <el-tab-pane label="已分组" name="grouped"></el-tab-pane>
                <el-tab-pane label="未分组" name="ungrouped"></el-tab-pane>
              </el-tabs>
            </div>
            <div v-show="groupingTab === 'grouped'">
              <GroupedList
                ref="groupedList"
                @open-add="openGroupFormAdd"
                @open-edit="openGroupFormEdit"
                @open-bind="openBindDialog"
              />
            </div>
            <div v-show="groupingTab === 'ungrouped'">
              <UngroupedList :active="groupingTab === 'ungrouped'" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <DirectGroupAddDialog
      :visible="showGroupForm"
      :group-id="groupForm.id"
      :initial-name="groupForm.name"
      @close="closeGroupForm"
      @success="onGroupFormSuccess"
    />
    <DirectGroupBindDialog
      :visible="showBindDialog"
      :group-id="bindTarget.id"
      :group-name="bindTarget.name"
      @close="closeBindDialog"
      @success="onBindSuccess"
    />
    <ConsultFloatBar v-if="isIndivConsult" />
  </div>
</template>

<script>
/** 账户分组（from=indiv）：已分组 / 未分组 Tab，含添加组、绑定账户 */
import { isIndivMixin } from '@/utils/isIndiv';
import '@/assets/icon1/iconfont.css';
import ConsultFloatBar from '@/components/consultFloatBar/index.vue';
import GroupedList from './GroupedList.vue';
import UngroupedList from './UngroupedList.vue';
import DirectGroupAddDialog from './DirectGroupAddDialog.vue';
import DirectGroupBindDialog from './DirectGroupBindDialog.vue';

export default {
  name: 'ClientGrouping',
  mixins: [isIndivMixin],
  components: {
    GroupedList,
    UngroupedList,
    ConsultFloatBar,
    DirectGroupAddDialog,
    DirectGroupBindDialog,
  },
  data() {
    return {
      groupingTab: 'grouped',
      showGroupForm: false,
      groupForm: {
        id: null,
        name: '',
      },
      showBindDialog: false,
      bindTarget: {
        id: null,
        name: '',
      },
    };
  },
  computed: {
    isIndivConsult() {
      return this.isIndiv;
    },
    /** 本页固定为 indiv 版式，contnet 有 margin-bottom:20px，minHeight 在基准上 +10px */
    groupingContnetMinHeight() {
      const base = document.documentElement.clientHeight - 141;
      return `${base + 20}px`;
    },
  },
  methods: {
    openGroupFormAdd() {
      this.groupForm = { id: null, name: '' };
      this.showGroupForm = true;
    },
    openGroupFormEdit({ groupId, groupName }) {
      this.groupForm = {
        id: groupId,
        name: groupName != null ? String(groupName) : '',
      };
      this.showGroupForm = true;
    },
    closeGroupForm() {
      this.showGroupForm = false;
      this.groupForm = { id: null, name: '' };
    },
    onGroupFormSuccess(payload) {
      const isEdit = payload && payload.mode === 'edit';
      this.$message.success(isEdit ? '修改成功' : '添加成功');
      const ref = this.$refs.groupedList;
      if (ref && typeof ref.loadGroupList === 'function') {
        ref.loadGroupList();
      }
    },
    openBindDialog({ groupId, groupName }) {
      this.bindTarget = {
        id: groupId,
        name: groupName != null ? String(groupName) : '',
      };
      this.showBindDialog = true;
    },
    closeBindDialog() {
      this.showBindDialog = false;
      this.bindTarget = { id: null, name: '' };
    },
    onBindSuccess() {
      this.$message.success('保存成功');
      const ref = this.$refs.groupedList;
      if (ref && typeof ref.loadGroupList === 'function') {
        ref.loadGroupList();
      }
    },
  },
};
</script>

<style scoped src="./style.css"></style>



// WEBPACK FOOTER //
// src/view/client/grouping/index.vue